export default __webpack_public_path__ + "static/media/heroku.ccf3f92a.svg";